import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center h-full text-light-black gap-10 rounded-3xl max-w-[25rem] bg-white px-5 py-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black text-center" }, "Employee your company email", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-center pb-3" }, [
  /*#__PURE__*/_createTextVNode(" Return to "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-primary-violet",
    href: "/login"
  }, "Log in page")
], -1)
const _hoisted_4 = { class: "flex flex-col justify-center items-center h-full text-light-black gap-10 bg-white px-5 py-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black" }, "Verify your employee account", -1)
const _hoisted_6 = { class: "flex flex-col justify-center items-center h-full text-light-black gap-10 bg-white px-5 py-10 rounded-3xl" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black" }, "Set your password", -1)
const _hoisted_8 = { class: "w-full flex flex-col" }
const _hoisted_9 = { class: "text-error text-sm" }

import { ref, computed, onMounted } from "vue"
  import { IonPage } from "@ionic/vue"
  import { useRoute, useRouter } from "vue-router"
  import { useAuthenticationStore } from "@/store/authentication"
  import { useAccountStore } from "@/store/account"
  import { generateSchema } from "@/utils/validate"
  import * as jwt from "@/utils/jwt"

  import WbTemplate from "@/components/account-creation/template.vue"
  import WbInput from "@/components/template/InputTemplate.vue"
  import VerifyPage from "@/views/VerifyPage.vue"
  import SixDigitContainer from "@/components/template/SixdigitCode.vue"
  import PasswordContainer from "@/components/template/PasswordTemplate.vue"
  import FormContainer from "@/components/template/formTemplate.vue"
  import LoginEmailPage from "@/views/LoginEmail.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginEmail',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const authenticationStore = useAuthenticationStore()
  const accountStore = useAccountStore()
  const loginAs = "employee"
  const accountStatus = computed(() => route.query.status || "")
  const employeeEmail = ref("")
  const userEmail = computed(() => accountStore.email)
  const verification = computed({
    get: () => authenticationStore.verificationCode,
    set: (val) => {
      authenticationStore.setVerificationCode(val)
    },
  })
  const passwordInput = ref("")
  const passwordConfirm = ref("")
  const passwordMatch = computed(() => (passwordInput.value.length || passwordConfirm.value.length ? passwordInput.value === passwordConfirm.value : true))

  const emailFormSchema = generateSchema([
    {
      name: "email",
      rule: "corporateEmail",
    },
  ])
  const verifyEmployeeSchema = generateSchema([
    {
      name: "sixDigitCode",
      rule: "sixDigitCode",
    },
  ])
  const passwordSchema = generateSchema([
    {
      name: "newpassword",
      rule: "password",
    },
    {
      name: "confirmpassword",
      rule: "stringRequired",
    },
  ])

  /**
   *
   * @param as - employee | professional (string)
   * @param status - invited | pending | active (string)
   * @param replace - default false (boolean)
   *
   * to login route
   */
  const toRoute = (as: "employee" | "professional", status?: "invited" | "pending" | "active", replace = false) => {
    if (as === "professional") authenticationStore.loginDetails.type = "professional"
    if (replace) router.replace(`/login?as=${as}${status ? `&status=${status}` : ""}${route.query.redirect ? `&redirect=${route.query.redirect}` : ""}`)
    else router.push(`/login?as=${as}${status ? `&status=${status}` : ""}${route.query.redirect ? `&redirect=${route.query.redirect}` : ""}`)
  }

  /**
   * verify employee email
   */
  const submitEmailForm = async (passedEmail?: string) => {
    if (typeof passedEmail == "string" && passedEmail && passedEmail.length) employeeEmail.value = passedEmail
    const response = await authenticationStore.verifyEmail({ email: employeeEmail.value, as: "employee" }, jwt.default.generateNBF())
    if (response.success) {
      if (response.message === "OTP sent") {
        localStorage.setItem("employee-email", employeeEmail.value)
        accountStore.email = employeeEmail.value
        toRoute("employee", "invited")
      } else if (response.status === "pending" && response.token) {
        localStorage.setItem("employee-email", employeeEmail.value)
        localStorage.setItem("employee-token", response.token)
        toRoute("employee", "pending", true)
      } else if (response.status === "active") {
        localStorage.removeItem("employee-email")
        localStorage.removeItem("employee-token")
        localStorage.setItem("employee-email-active", employeeEmail.value)
        accountStore.email = employeeEmail.value
        authenticationStore.loginDetails.email = employeeEmail.value
        authenticationStore.loginDetails.type = "employee"
        toRoute("employee", "active", true)
      }
    }
  }

  /**
   * verify employee with otp
   */
  const verifyEmployee = async () => {
    authenticationStore.setVerificationCode({ email: userEmail.value, as: "employee" })
    const isVerified = await authenticationStore.verifyCode(jwt.default.generateNBF(), false)
    if (isVerified) {
      await submitEmailForm(userEmail.value)
    }
  }

  /**
   * resend OTP
   */
  const resendOTP = () => {
    authenticationStore.requestOTP(userEmail.value, jwt.default.generateNBF())
  }

  /**
   * set employee password
   */
  const setEmployeePassword = async () => {
    const emailStored = localStorage.getItem("employee-email")
    const tokenStored = localStorage.getItem("employee-token")
    if (passwordInput.value.length && passwordMatch.value && emailStored && tokenStored) {
      const isPasswordSet = await authenticationStore.changePassword({ password: passwordInput.value, old_password: passwordInput.value }, jwt.default.generateNBF(), tokenStored)
      if (isPasswordSet) {
        await submitEmailForm(emailStored)
      } else toRoute("employee", undefined, true)
    }
  }

  onMounted(() => {
    if (
      (route.query.as && route.query.as.length && route.query.as !== "employee" && route.query.as !== "professional") ||
      (route.query.as &&
        route.query.as.length &&
        route.query.as === "employee" &&
        route.query.status &&
        route.query.status.length &&
        route.query.status !== "invited" &&
        route.query.status !== "pending" &&
        route.query.status !== "active")
    )
      router.replace("/not-found")
    else if (route.query.as === "employee" && route.query.status === "invited") {
      const emailStored = localStorage.getItem("employee-email")
      const tokenStored = localStorage.getItem("employee-token")
      if (tokenStored) {
        toRoute("employee", "pending", true)
      } else if (emailStored) {
        accountStore.email = emailStored
      } else toRoute("employee", undefined, true)
    } else if (route.query.as === "employee" && route.query.status === "pending") {
      const emailStored = localStorage.getItem("employee-email")
      const tokenStored = localStorage.getItem("employee-token")
      if (!tokenStored || !emailStored) toRoute("employee", undefined, true)
    } else if (route.query.as === "employee" && route.query.status === "active") {
      const emailStored = localStorage.getItem("employee-email-active")
      if (emailStored) {
        accountStore.email = emailStored
        authenticationStore.loginDetails.email = emailStored
        authenticationStore.loginDetails.type = "employee"
      } else toRoute("employee", undefined, true)
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(WbTemplate, null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(FormContainer, {
              "validation-schema": _unref(emailFormSchema),
              class: "flex flex-col w-full items-center justify-center text-light-black px-5 gap-10",
              onValid: submitEmailForm
            }, {
              default: _withCtx(() => [
                _createVNode(WbInput, {
                  modelValue: employeeEmail.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((employeeEmail).value = $event)),
                  name: "email",
                  type: "email",
                  placeholder: "Email*"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ion_button, {
                  expand: "block",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Continue")
                  ]),
                  _: 1
                }),
                _hoisted_3
              ]),
              _: 1
            }, 8, ["validation-schema"])
          ], 512), [
            [_vShow, loginAs === 'employee' && _unref(accountStatus) === '']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", null, "Please enter the 6 digit code sent to " + _toDisplayString(_unref(userEmail)), 1),
            _createVNode(FormContainer, {
              "validation-schema": _unref(verifyEmployeeSchema),
              class: "max-w-[400px] w-full align-middle flex flex-col gap-9",
              onValid: verifyEmployee
            }, {
              default: _withCtx(() => [
                _createVNode(SixDigitContainer, {
                  modelValue: _unref(verification).otp,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(verification).otp) = $event)),
                  name: "sixDigitCode",
                  class: "mx-auto"
                }, null, 8, ["modelValue"]),
                _createElementVNode("p", { class: "text-center pb-3" }, [
                  _createTextVNode(" Didn’t receive an email? "),
                  _createElementVNode("span", {
                    class: "text-primary-violet underline cursor-pointer",
                    onClick: resendOTP
                  }, "Resend code.")
                ]),
                _createVNode(_component_ion_button, {
                  expand: "block",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Continue")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["validation-schema"])
          ], 512), [
            [_vShow, loginAs === 'employee' && _unref(accountStatus) === 'invited']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(FormContainer, {
              "validation-schema": _unref(passwordSchema),
              class: "max-w-[400px] w-full align-middle flex flex-col gap-9",
              onValid: setEmployeePassword
            }, {
              default: _withCtx(() => [
                _createVNode(PasswordContainer, {
                  modelValue: passwordInput.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordInput).value = $event)),
                  name: "newpassword",
                  placeholder: "Password*",
                  autocomplete: "new-password"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(PasswordContainer, {
                    modelValue: passwordConfirm.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((passwordConfirm).value = $event)),
                    name: "confirmpassword",
                    placeholder: "Confirm password*",
                    autocomplete: "confirm-password"
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("span", _hoisted_9, "Password not matched", 512), [
                    [_vShow, !_unref(passwordMatch)]
                  ])
                ]),
                _createVNode(_component_ion_button, {
                  expand: "block",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Continue")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["validation-schema"])
          ], 512), [
            [_vShow, loginAs === 'employee' && _unref(accountStatus) === 'pending']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})